var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPieChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 101,
    height: 101,
    viewBox: "0 0 101 101",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2",
    "data-name": "Rectangle 2",
    width: 101,
    height: 101,
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pie-chart",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M66.821,46.076H38.1A20.4,20.4,0,0,0,21.326,29.364V.653a48.557,48.557,0,0,1,31.29,14.213A48.551,48.551,0,0,1,66.821,46.076Z",
    transform: "translate(32.522 0.996)",
    fill: "#ff7258"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M21.326,16.046V9.386A27.02,27.02,0,0,1,44.77,32.758H38.1A20.4,20.4,0,0,0,21.326,16.046Z",
    transform: "translate(32.522 14.314)",
    fill: "#f95d48"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M58.82,21.252A48.481,48.481,0,0,1,46.889,50.167L31.332,34.61,26.58,29.857a20.234,20.234,0,0,0,3.538-8.605Z",
    transform: "translate(40.534 32.409)",
    fill: "#ffdc65"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M36.79,21.252A26.852,26.852,0,0,1,31.332,34.61L26.58,29.857a20.234,20.234,0,0,0,3.538-8.605Z",
    transform: "translate(40.534 32.409)",
    fill: "#ffc846"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M81.775,86.245a48.907,48.907,0,0,1-66.8-71.38A48.546,48.546,0,0,1,46.264.653V29.364A20.353,20.353,0,1,0,61.472,65.942Z",
    transform: "translate(0.994 0.995)",
    fill: "#00abe0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M48.277,52.632,53.043,57.4A27.009,27.009,0,1,1,33.069,9.381v6.673A20.353,20.353,0,1,0,48.277,52.632Z",
    transform: "translate(14.189 14.306)",
    fill: "#099dd1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M67.816,48.717H39.1a1.646,1.646,0,0,1-1.624-1.375,18.687,18.687,0,0,0-15.42-15.361,1.647,1.647,0,0,1-1.381-1.625V1.648A1.647,1.647,0,0,1,22.429,0,50.208,50.208,0,0,1,48.537,9.383a1.647,1.647,0,0,1-1.928,2.67A46.89,46.89,0,0,0,23.967,3.44V29A21.982,21.982,0,0,1,40.448,45.424H66.023A46.582,46.582,0,0,0,53.836,18.476a1.647,1.647,0,0,1,2.424-2.23,49.875,49.875,0,0,1,13.2,30.713,1.647,1.647,0,0,1-1.643,1.758Z",
    transform: "translate(31.528 0.001)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M47.884,52.809a1.648,1.648,0,0,1-1.165-.482l-20.31-20.31a1.647,1.647,0,0,1-.174-2.123,18.716,18.716,0,0,0,3.252-7.906A1.646,1.646,0,0,1,31.113,20.6h28.7a1.646,1.646,0,0,1,1.644,1.752A49.933,49.933,0,0,1,49.124,52.246a1.647,1.647,0,0,1-1.184.563ZM29.693,30.642,47.781,48.729A46.581,46.581,0,0,0,58.026,23.893H32.471A22.07,22.07,0,0,1,29.693,30.642Z",
    transform: "translate(39.538 31.415)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M50.554,101A50.553,50.553,0,0,1,47.15,0a1.647,1.647,0,0,1,1.755,1.643V30.357a1.646,1.646,0,0,1-1.381,1.625A18.706,18.706,0,1,0,61.5,65.6a1.647,1.647,0,0,1,2.13.169l20.3,20.3a1.647,1.647,0,0,1-.078,2.4A50.441,50.441,0,0,1,50.554,101ZM45.612,3.44a47.261,47.261,0,1,0,34.726,83.7L62.262,69.062a21.8,21.8,0,0,1-11.709,3.381A22,22,0,0,1,45.612,29Z",
    transform: "translate(0 0.002)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieChart);
export default __webpack_public_path__ + "static/media/pie-chart.d4f04ce04dd809994359b0ef3f363a29.svg";
export { ForwardRef as ReactComponent };